import useAgentHandlerLinkModalContext from "../context/useAgentHandlerLinkModalContext";
import NextStepButton from "../shared/NextStepButton";
import { Connector } from "../../config/types";
import InterstitialScreen from "./InterstitialScreen";

type Props = {
  customText?: string;
  customSubText?: string;
  onClickBottomAction?: () => void;
  buttonText?: string;
  connector?: Connector;
  };
const LoadingScreen = ({
  customText,
  customSubText,
  onClickBottomAction,
  buttonText,
  connector,
}: Props) => {
  const { onExit } = useAgentHandlerLinkModalContext();

  return (
    <InterstitialScreen
      centralIcon={
        <div className="flex items-center justify-center h-[60px]">
          <span className="inline-block animate-[spin_0.75s_linear_infinite] rounded-full border-solid border-current border-r-transparent size-[54px] border-[3.75px] text-gray-40" />
        </div>
      }
      onExit={onExit}
      text={customText}
      subText={customSubText}
      connector={connector}
      bottomAction={
        <NextStepButton
          inverted
          onClick={onClickBottomAction ? () => onClickBottomAction() : () => onExit()}
        >
          {buttonText ?? "Close window"}
        </NextStepButton>
      }
    />
  );
};

export default LoadingScreen;
